import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, AbstractControl, FormControl, Validators } from '@angular/forms'; 
import { department, interaction, user } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { UtilityService } from './../../../services/utility.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { element } from 'protractor';
import Swal from 'sweetalert2'
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
 import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';


@Component({
  selector: 'app-interaction',
  templateUrl: './interaction.component.html',
  styleUrls: ['./interaction.component.css']
})
export class InteractionComponent implements OnInit {
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  modalRef: BsModalRef;
  @ViewChild('editSettingsTemplate', { static: false }) editTemplate: TemplateRef<any>;
  public title: string = 'Add Role';
  public data: any;
  public interaction_data: any;
  public user_data: any;
  public editSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
  public interactionData: object[];
  public interactionForm: FormGroup;
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  public permission: number = 1;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;

  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
    searchText: string;
    dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: AdminApiService, private modalService: BsModalService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      //User rights
      this.editSettings = { allowEditing: this.permision_edit, allowAdding: this.permision_add, allowDeleting: this.permision_delete, mode: 'Dialog' };
      this.toolbar = this.userService.getRights_ToolbarWithoutExcel(this.permision_add, this.permision_edit, this.permision_delete);
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.loadInteraction();    
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    
  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("Interaction");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        //User rights
        this.editSettings = { allowEditing: this.permision_edit, allowAdding: this.permision_add, allowDeleting: this.permision_delete, mode: 'Dialog' };

        this.toolbar = this.userService.getRights_Toolbar(this.permision_add, this.permision_edit, this.permision_delete);

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  // Get interaction list
  loadInteraction() {
    this.spinner.show();
    let inpValue = new interaction();    
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getInteractions(inpValue)
      .subscribe(data => {
        
        this.data = data;
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            interactionUno: this.data[i].interactionUno,
            interactionNameEn: this.data[i].interactionNameEn,
            interactionNameAr: this.data[i].interactionNameAr
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      }); 
  }
   
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  addItem() {
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "add";
    this.submitClicked = false;

    this.title = 'Add Interaction';
    this.interactionForm = new FormGroup({
      interactionUno: new FormControl(0),
      interactionNameEn: new FormControl('', Validators.required),
      interactionNameAr: new FormControl('', Validators.required)

    });
  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.interactionNameEn && a.interactionNameEn.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'interactionNameEn', name: 'Interaction', field: 'interactionNameEn', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'interactionNameEn', 'interactionNameEninteractionNameEn'),
          model: Filters.multipleSelect,
        }
      },
   

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', maxWidth: 100,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'edit_row', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-edit fa-lg', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                this.pageAction = 'Edit';
                let data = args.dataContext;
                if (this.permission == 1)
                  return true;
                else false;
              },
              action: (e, args) => {
                if (this.permission == 1) {
                  this.submitClicked = false;
                  this.title = 'Details of ' + args.dataContext.interactionNameEn;
                  this.interactionForm = this.createFormGroup(args.dataContext);
                  this.modalRef = this.modalService.show(
                    this.editTemplate,
                    Object.assign({}, {
                      class: 'gray modal-xl',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                  
                }
              }
            },
            {
              command: 'delete-row', titleKey: 'del_row', positionOrder: 65, title: 'Delete',
              iconCssClass: 'fa fa-trash fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                
                if (this.permission == 1)
                  return true;
                else false;
              },
              action: (e, args) => {
                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.pageAction = 'delete';
                    this.DeleteInteraction(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              }
            },


          ],
        }
      }

    ]


  }


  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (this.permission == 1)
      return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
    else
      return '';
  };



  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }


  createFormGroup(data1: any): FormGroup {
    
    return new FormGroup({
      interactionUno: new FormControl(data1.interactionUno),
      interactionNameEn: new FormControl(data1.interactionNameEn, Validators.required),
      interactionNameAr: new FormControl(data1.interactionNameAr, Validators.required)
     
    });
  }

  saveInteraction() {
    this.submitClicked = true;
    if (this.interactionForm.valid) {
      this.AddEditInteraction(this.interactionForm.value);
    } else {
    //  Swal.fire('Error', 'Enter the required values', 'error')
      this.toaster.show('error', 'Error', 'Enter the required values.');
    }
  }

  AddEditInteraction(data1: any) {

    
    let objInteraction = new interaction();
    objInteraction.actionType = this.pageAction;
    objInteraction.interactionUno = (this.pageAction == "add") ? 0 : data1.interactionUno;
    objInteraction.interactionNameEn = this.utilityService.isStringNull(data1.interactionNameEn);
    objInteraction.interactionNameAr = this.utilityService.isStringNull(data1.interactionNameAr);   
    objInteraction.userUno = this.login_UserID;
    objInteraction.tenantUno = this.tenantUno;
    
    this.restApi.addEditInteraction(objInteraction)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
         this.modalRef.hide();
          this.toaster.show('success', 'Success', (this.pageAction == "add") ? 'Interaction saved.' : 'Interaction updated.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Interaction saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadInteraction();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  DeleteInteraction(data1: any) {

    let objInteraction = new interaction();
    objInteraction.actionType = this.pageAction;
    objInteraction.interactionUno = data1.interactionUno;
    objInteraction.userUno = this.login_UserID;
    objInteraction.tenantUno = 1;
    
    this.restApi.deleteInteraction(objInteraction)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'Interaction deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Interaction deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadInteraction();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }
   

 
  
  get interactionNameEn(): AbstractControl { return this.interactionForm.get('interactionNameEn'); }

  get interactionNameAr(): AbstractControl { return this.interactionForm.get('interactionNameAr'); }
 
}
